/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import classes from "./order.module.css";
import DialogContent from "@mui/material/DialogContent";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Draggable from "react-draggable";
import { Paper, Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Get order props from parent (View Order page)
const ResendDialog = (props) => {
  const t = props.t;
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  // Send email
  const sendMail = async () => {
    setLoading(true);
    let data = {
      emailId: email,
    };
    BusApiCall(
      "PUT",
      `${constants.busInternalUrl}/orders/${props.orderId}/tncs`,
      data,
    )
      .then((res) => {
        setLoading(false);
        setMsg(t("E-MAIL_HAS_BEEN_SENT_SUCCESSFULLY"));
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
        setMsg(t("DEFAULT_ERROR_MESSAGE"));
      });
  };

  return (
    <React.Fragment>
      <Dialog
        disableScrollLock={true}
        PaperComponent={DraggableDialogPaper}
        maxWidth={"md"}
        fullWidth={true}
        open={props.isOpen}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {t("RE-SEND_TERMS_&_CONDITIONS_EMAIL")}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => {
                  props.close();
                }}
                onClick={() => {
                  props.close();
                }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          {msg ? (
            msg
          ) : (
            <Input
              inputClass={classes.inputClass}
              name={"email"}
              placeholder={t("EMAIL")}
              // label={'Email'}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          )}
        </DialogContent>
        <DialogActions>
          {msg ? (
            <Button
              onClick={() => {
                setEmail("");
                setMsg("");
                props.close();
              }}
            >
              {t("OK")}
            </Button>
          ) : (
            <React.Fragment>
              {/* <Button onClick={() => { props.close() }}>{t('CLOSE')}</Button> */}
              <Button
                onClick={() => {
                  sendMail();
                }}
              >
                {t("SUBMIT")}
              </Button>
            </React.Fragment>
          )}
        </DialogActions>
      </Dialog>
      <Loader loading={loading} />
    </React.Fragment>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(ResendDialog);
